import { Row, Col } from 'antd';

const OverlayTable = ({ filteredKeys, customColumn }) => (
  <div className='overlay-table'>
    {filteredKeys.map((key, index) => (
      <Row
        className={index % 2 === 0 ? 'overlay-even-row' : 'overlay-odd-row'}
        key={key}
      >
        <Col span={12} className='overlay-column'>
          {key}
        </Col>
        <Col span={12} className='overlay-column'>
          {customColumn(key)}
        </Col>
      </Row>
    ))}
  </div>
);

export default OverlayTable;